var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preload_show)?_c('div',{staticClass:"preload fixed w-full h-full top-0 left-0 bg-white z-50",attrs:{"id":"preloader"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }